import { render } from "./DefaultFilter.vue?vue&type=template&id=47fc0793"
import script from "./DefaultFilter.vue?vue&type=script&lang=js"
export * from "./DefaultFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__